<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('cancel')">
        <div class="modal-container" @click.stop>
          <div class="modal-header d-sm-block d-none">
            <slot name="header"><h1>Bid Details</h1></slot>
          </div>

          <div class="d-sm-none">
            <b-button-close @click="$emit('cancel')"/>
            <h4>Bid Details</h4>
          </div>

          <div class="modal-body">
            <slot name="body">
              <b-row>
                <b-col cols="12" v-if="!submittedSucessfully">
                  <b-row>
                    <b-col cols="12" sm="8">
                      <b-form-row>
                        <b-col cols="3" class="col-form-key">Net Price</b-col>
                        <b-col cols="9">{{ watch.offerPrice }} EUR</b-col>
                      </b-form-row>
                      <b-form-row>
                        <b-col cols="3" class="col-form-key">Comment</b-col>
                        <b-col cols="9">
                          <textarea class="form-control" v-model="bidComment" :disabled="currentlySending"></textarea>
                        </b-col>
                      </b-form-row>
                    </b-col>
                    <b-col cols="12" sm="4" class="text-center">
                      <div v-if="!currentlySending">
                        <b-button variant="success" size="lg" class="btn-bid" @click="submitBid()">
                          Submit Bid
                        </b-button>
                        * non-binding
                      </div>
                      <div class="sending-bid-div" v-if="currentlySending">
                        Sending &nbsp; <b-spinner/>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" v-else class="text-center">
                  <div class="alert alert-success alert-bid-value-success">
                    <b-spinner/>
                    Successfully sent bid value of »{{ watch.offerPrice }} EUR«<br /><br />
                    <b-button variant="success" @click="$emit('cancel')">
                      <b-icon-x/> Close
                    </b-button>
                  </div>
                </b-col>
                <b-col cols="12" v-if="error.addBid" class="text-left mt-3">
                  <div class="alert alert-danger" role="alert">
                    Your bid could not be sent. Please contact us at
                    <a href="mailto:b2b@chronext.com">b2b@chronext.com</a> if the problem persists.
                  </div>
                </b-col>
              </b-row>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import constants from 'src/constants/constants';
import currencies from 'src/constants/currencies';
import apiAuth from 'src/clients/apiAuth';

export default {
  name: 'BidForm',
  props: ['watch', 'bidData'],
  data: function() {
    return {
      currencyOptions: currencies.currencies,
      currencySelected: 'EUR',
      currentlySending: false,
      submittedSucessfully: false,
      bidValue: '',
      bidComment: '',
      error: {
        addBid: false,
      },
    };
  },
  methods: {
    submitBid() {
      console.log('Submit Bid');
      let options = {
        method: 'post',
        url: constants.url.offerService.baseUrl + constants.url.offerService.api.postBid,
        data: {
          comment: this.bidComment,
          watch: this.watch,
          currency: 'EUR',
          reserveNetPrice: this.watch.offerPrice,
        },
      };

      this.currentlySending = true;
      this.error.addBid = false;
      apiAuth(options)
        .then(() => {
          this.submittedSucessfully = true;
          console.log('Submit successful');
          this.currentlySending = false;
          this.$ga.event({
            eventCategory: 'BidForm',
            eventAction: 'click_submit_button',
            eventLabel: 'Submit Bid for watch ' + this.watch['itemId'],
          });
        })
        .catch(() => {
          console.log('Submit not successful');
          this.currentlySending = false;

          this.error.addBid = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.sending-bid-div {
  font-size: 1.3rem;
}

.col-form-key {
  text-align: right;
}

.btn-bid {
  width: 100%;
}

.alert-bid-value-success {
  margin-bottom: 0;
}

.row-form {
  margin-bottom: 8px;
}
</style>
